module.exports = __webpack_public_path__ + "img/card2_img_1.523f7bf3.jpg";